import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { roleNames } from "../constant";

const PublicRoute = ({ children }) => {
  const token = useSelector((state) => state.auth.jwtToken);
  const role = useSelector((state) => state.auth.role);

  if (token) {
    switch (role) {
      case roleNames.superAdmin:
      case roleNames.admin:
        return <Navigate to="/admin-dashboard" replace />;

      case roleNames.qa:
      case roleNames.qualityLead:
      case roleNames.qualityAssurance:
      case roleNames.opsTeamLead:
      case roleNames.opsLead:
        return <Navigate to="/qa-dashboard" replace />;

      case roleNames.trainer:
        return <Navigate to="/manage-qas" replace />;

      case roleNames.traininglead:
        return <Navigate to="/manage-qas" replace />;

      default:
        return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
};

export default PublicRoute;
